import { defineMessages } from 'react-intl';

export default defineMessages({
    emptyDocumentMessage: {
        id: "platform.documentupload.templates.document-upload.There are no documents associated with this Policy",
        defaultMessage: "There are no documents associated with this Policy"
    },
});
